<template>
    <div class="panel">
            <div class="row" v-for="row in imagesCollection" v-bind:id="row.idName" :style="getStyle(row)">
                <div class="label label-front" v-if="row.idName != 'male-female-row'">Front</div>
                <div class="label label-back" v-if="row.idName != 'male-female-row'">Back</div>
                <div class="col body-image" v-for="image in row.images" v-bind:class="{ 'body-image-container': notGender(image) }" :style="doImagePlacement(image, row)">
                    <transition name="slide" appear>
                        <img :src="image.offFile" :class="image.text.toLowerCase()" @click="selectImage(image)" @mouseover="doHoverState(image, 'hover')" @mouseout="doHoverState(image, '')" />
                    </transition>
                </div>
            </div>
    </div>
</template>

<script>
    import response from '@/stores/response.js'
    import imageStore from '@/stores/images.js'

    export default {
        name: 'Body_panel',
        created: function () {
            var self = this;
            self.$root.$once('next-panel', function() {
                self.saveData();
            });
        },
        data: function () {
            return {
                selectedValues: [],
                selectedImage: null,
                imagesCollection: imageStore,
                response: response
            };
        },
        methods: {
            selectImage: function (image) {
                var textLower = image.text.toLowerCase();
                this.selectedImage = image;
                if (image.text == 'Male' || image.text == 'Female') {
                    CodeBaby.jQuery('#male-female-row').hide();
                    CodeBaby.jQuery('#' + textLower + '-row').css('display', 'flex');
                    CodeBaby.fire('Body_Gender');
                    this.$root.$emit('nlp-response', {answerText: this.$parent.scenes['Body_m_f']});
                }else{
                    var valueIndex = this.selectedValues.indexOf(image.text);
                    if(valueIndex != -1) {
                        //console.log(textLower + ' ' + image.offFile);
                        this.selectedValues.splice(valueIndex, 1);
                        CodeBaby.jQuery('.' + textLower + ':visible').attr('src: ' + image.offFile);
                        CodeBaby.jQuery('.' + textLower + ':visible').removeClass('active');
                    } else {
                        //console.log(textLower + ' ' + image.onFile);
                        CodeBaby.jQuery('.' + textLower + ':visible').attr('src: ' + image.onFile);
                        CodeBaby.jQuery('.' + textLower + ':visible').addClass('active');
                        this.selectedValues.push(image.text);
                    }
                    return;
                }
                this.selectedValues.push(image.text);
            },
            saveData: function () {
                console.log(this.$parent.panelState.curPanel);
                this.response[(this.$parent.panelState.curPanel - 1)].answer = this.selectedValues;
                console.log(this.response);
            },
            doHoverState: function(image, state) {
                var el = CodeBaby.jQuery('.' + image.text.toLowerCase() + ':visible');
                if(el.hasClass('active')) return; // bail out if selected
                var newState = (state === 'hover') ? image.hoverFile : image.offFile;
                el.attr({src: newState})
            },
            notGender: function(image) {
                return(image.text !== "Male" && image.text !== "Female");
            },
            doImagePlacement: function(image, row) {
                if (!this.notGender(image)) return;
                var baseOffsetTop = 130;
                var baseOffsetLeft = (image.text.indexOf('Back') === -1) ? 130 : 360;
                var basezIndex = 5000;
                baseOffsetLeft += (row.idName != 'female-row') ? 0 : 11;
                return { left: image.xPos + baseOffsetLeft + 'px', top: baseOffsetTop + image.yPos + 'px', "z-index": (image.zIndex + basezIndex), opacity: 1 };
            },
            getStyle: function (row) {
                var styleObj = (row.idName == 'male-female-row') ? null : (row.idName == 'male-row') ? {'background-color' : '#8393ca'} : {'background-color' : '#f49ac1'};
                return (styleObj);
            }
        }
    }
</script>
<style scoped lang="stylus">
.panel
    .slide-enter, .slide-leave-to
        transform: translateY(-100%)
    .slide-leave-active, .slide-enter-active
        transition: 1s
.row
    display: flex
    justify-content: center
    flex: 1
    border-radius: 10%
    &#male-row,
    &#female-row
        display: none
    .label
        color: #FFF
        position: relative
        display: inline-block
        font-weight: bold
        top: 20px
        width: 225px
        text-align: center
    .col
        padding: 1em
        &.body-image-container
            position: absolute
            top: 0
            left: 0
            padding: 0
            margin: 0
        &.body-image
            cursor: pointer
.hidden-checkbox-container
    display:none
</style>